import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { firstValueFrom } from 'rxjs';
import { LocalizationActions } from '../store/localization.action';

@Injectable()
export class LocalizationInitializerService {
  public constructor(private store: Store) {}

  public initializeLocalizationLanguages(): Promise<void> {
    return firstValueFrom(this.store.dispatch(new LocalizationActions.InitializeLanguages()));
  }
}
